import React from "react";
import { formatCurrency } from "../../shared/utils";
import moment from "moment";

const RenderInstallment = ({ paymentMethod, installments }) => {
    if (paymentMethod === "credit-card") {
        return `(Parcelado em ${installments}x )`;
    }
    return "Transferência";
};

const RenderOrders = ({ order }) => {
    return (
        <React.Fragment>
            <div className="order-wrapper">
                <div className="order-info-col">
                    <span className="order-info-col-title small-title">Código da compra:</span>
                    <span className="order-info-col-data big color">{order.code}</span>
                </div>

                <div className="order-info-col">
                    <span className="order-info-col-title small-title">Localizador do voo:</span>
                    <span className="order-info-col-data big color">{order.eticket}</span>
                </div>

                <div className="order-info-col">
                    <span className="order-info-col-title small-title">Data da compra:</span>
                    <span className="order-info-col-data small weight">
                        {moment(order.purchaseDate.substr(0, 10)).format('D/MM/Y')}
                    </span>
                </div>

                <div className="order-info-col">
                    <span className="order-info-col-title small-title">Valor total:</span>
                    <span className="order-info-col-data small weight">
                        {formatCurrency(order.billing.value)}
                    </span>
                    <small>
                        <RenderInstallment 
                            paymentMethod={order.paymentMethod} 
                            installments={order.billing.installments}
                        />
                    </small>
                </div>
            </div>
        </React.Fragment>
    );
}

const OrderResume = ({ order }) => {
    return (
        <React.Fragment>
            <RenderOrders order={order}></RenderOrders>
        </React.Fragment>
    );
}

export default OrderResume;
